import { render, staticRenderFns } from "./lock_list.vue?vue&type=template&id=8e88dcc4"
import script from "./lock_list.vue?vue&type=script&lang=ts"
export * from "./lock_list.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports